import Image from 'next/image';
import type { FC } from 'react';

import type { SimpleFooterTranslations } from '@/translations';

import { Link } from '../link';

interface Props {
  data: SimpleFooterTranslations;
}

export const SimpleFooter: FC<Props> = ({ data }) => {
  return (
    <footer className="simple-footer">
      <Link
        href={data.home.link?.uri || '#'}
        aria-label="Home"
        noStyle
        className="simple-footer--logo"
      >
        <Image
          src="/images/logo-short-gray.svg"
          alt="Logo"
          width={32}
          height={32}
        />
      </Link>
      {data.nav.map((navItem, index) => (
        <Link
          key={index}
          href={navItem.link?.uri || ''}
          noStyle
          className="simple-footer--link"
        >
          {navItem.text}
        </Link>
      ))}
      <div className="simple-footer--copyright">
        © {new Date().getFullYear()} {data.copyright}
      </div>
    </footer>
  );
};
